import { STAGE_PRICING } from "@/data/stagePricing";
import { IMAGES } from "@/data/site";

const GALERIE = (name) => `${process.env.REACT_APP_BACKEND_URL}/api/galerie/images/${name}_l.jpg`;

export const EDITIONS_SEO = {
  title: "Éditions limitées de tambours | Super Lune, Solstice & Lieux | Entre Les Mondes",
  description: "Découvrez les éditions limitées de création de tambours Entre Les Mondes : Super Lune, Solstice et Tambours des Lieux. Des expériences rares, artisanales et immersives.",
};

export const EDITIONS_INTRO = "Certaines créations ne suivent pas simplement une date. Elles naissent d'une lune, d'un lieu, d'un passage de saison ou d'un moment particulier de l'année.";

export const EDITIONS_IMAGES = {
  hero: IMAGES.mains,
  superLunePaysage: "/images/editions/super-lune.jpg",
  superLune: GALERIE("ff0fc64e34874d98ace52a1a5e3a4a50"),
  solsticePaysage: "/images/editions/solstice.jpg",
  solstice: "/images/stage/etape-3.jpg",
  lieux: "/images/editions/lieux.jpg",
  lieuxDetail: GALERIE("e3720265584c462a8eca4987edebb4ee"),
};

export const SUPER_LUNE = {
  id: "super-lune",
  eyebrow: "Édition limitée · nuit de pleine lune",
  titre: "Tambours de la Super Lune",
  texte: "Une création en soirée et durant la nuit, accordée au moment de la pleine lune. Plus intime et plus immersive que le stage de jour : le groupe est réduit, le rythme est celui de la nuit, et les tambours naissent ensemble au plus haut de la lune.",
  points: [
    "Création complète de votre tambour, du cadre à la mailloche",
    "Préférence de peau et taille validées avant la préparation, selon les disponibilités",
    "Montage artisanal et accompagnement à chaque étape",
    "Première mise en vibration, au cœur de la nuit",
    "Petit nombre de participant·e·s",
    "Édition limitée — non proposée toute l'année",
  ],
  prochaine: { date: "2027-01-22", label: "Vendredi 22 janvier 2027 · soirée & nuit" },
  cta: { label: "Découvrir l'édition Super Lune", to: "/super-lune" },
};

export const SOLSTICE = {
  id: "solstice",
  eyebrow: "Édition limitée · rendez-vous annuel",
  titre: "Tambours du Solstice",
  texte: "Au jour le plus long de l'année, une journée entière consacrée à la naissance de nouveaux tambours.",
  detail: "Cette édition est pensée comme un rendez-vous annuel exceptionnel, plus intime que le stage classique : un petit groupe, une journée qui suit la course du soleil, et une attention particulière portée à ce que le solstice met en jeu — la lumière à son sommet, juste avant qu'elle ne commence à décliner.",
  date: "2027-06-19", label: "Samedi 19 juin 2027 · journée complète", match: /solstice/i, type: "stage",
  faits: [
    { h: "Participant·e·s", t: "8 personnes au plus — chacun·e est accompagné·e à chaque étape." },
    { h: "Lieu", t: "Atelier Entre Les Mondes, Rue Pierre Viret 8, Orbe — avec des temps dehors si la lumière le permet." },
    { h: "Tambour", t: "Cadre, dimensions et préférence de peau confirmés en amont selon les disponibilités, mailloche comprise." },
    { h: "Tarif", t: `CHF ${STAGE_PRICING.groupeSpecial}.– par personne — cadre, peau, laçage, mailloche et accompagnement de la journée (peau de cheval, bison ou autruche : + CHF 100.–).` },
  ],
  deroulement: [
    { h: "Le matin — accueil dans la lumière", t: "Ouverture de la journée, présentation du solstice et de ce qu'il représente dans les traditions européennes. La peau, choisie et préparée en amont, est prête pour la découpe et la création." },
    { h: "Midi — pique-nique dehors", t: "Une pause au soleil, ensemble. Le repas n'est pas compris : apportez votre pique-nique." },
    { h: "L'après-midi — monter et lacer", t: "Tension de la peau sur le cadre, laçage, nœuds : le tambour prend forme au moment où le soleil est le plus haut." },
    { h: "Le soir — faire sonner", t: "Fabrication de la mailloche, consécration selon vos intentions, puis premiers battements partagés dans la longue lumière du soir." },
  ],
  materiel: ["Un bâton en bois d'environ 50 cm de long, 1 à 2 cm de diamètre (mailloche)", "Un t-shirt rempli de bons souvenirs — il deviendra la tête de votre mailloche", "Votre pique-nique et de l'eau", "Une tenue confortable, salissable, et de quoi vous protéger du soleil"],
  symbolique: "Le solstice d'été est le point de bascule de l'année : la lumière est à son maximum et, dès le lendemain, les jours raccourcissent. Dans les traditions d'Europe centrale et des terres celtes, c'est un temps de feux, de plénitude et de gratitude. Créer son tambour ce jour-là, c'est lui donner pour naissance ce moment de sommet — sans promesse particulière, mais avec une intention claire : accueillir ce qui est plein avant de laisser venir la saison qui décline.",
  cta: { label: "Réserver la création du Solstice", to: "/agenda" },
};

export const LIEUX = {
  id: "lieux",
  eyebrow: "Édition limitée · en plein air",
  titre: "Tambours des Lieux",
  accroche: "Un lieu. Une journée. Un tambour.",
  texte: "Certaines créations quittent l'atelier. Elles prennent place sur des sites choisis pour leur histoire, leur géologie, leur environnement et ce que l'on peut y expérimenter.",
  points: [
    "Création du tambour sur place, du début à la fin",
    "Site choisi avec soin, en Suisse romande",
    "Contexte historique, géologique ou énergétique partagé quand il est documenté",
    "Petit groupe — huit personnes au plus",
    "Une journée entière en extérieur",
    "Activité maintenue dehors, sauf situation exceptionnelle ou site particulier",
    "Équipement et difficulté d'accès indiqués pour chaque édition",
  ],
  vedette: "2027-09-18",
  cta: { label: "Découvrir les Tambours des Lieux", to: "/offres/tambours-lieux-anciens" },
  privee: {
    eyebrow: "Sur demande · mai à septembre",
    titre: "Sessions individuelles ou privatives, sur demande",
    texte: "En dehors des journées collectives datées, une création sur un lieu peut s'organiser à la demande — seul·e, à deux ou en petit groupe privé de 3 à 4 personnes — principalement en période estivale, de mai à septembre, lorsque les conditions en extérieur le permettent. Le lieu et la date se choisissent ensemble ; aucune date n'est fixée à l'avance.",
    points: ["Individuel sur haut lieu — CHF 750.–", "À deux — CHF 650.– par personne", "Privatisation 3 à 4 personnes — sur demande", "Date à convenir de mai à septembre"],
    cta: { label: "Organiser une création sur un lieu", to: "/contact?sujet=lieu-ancien" },
    cta2: { label: "Demander une session individuelle", to: "/offres/tambours-lieux-anciens#privee" },
  },
};

export const LIEUX_FICHES = [
  { slug: null, date: "2027-09-18", nom: "Édition du 18 septembre 2027", statut: "Lieu communiqué avant l'événement", texte: "Le site est repéré ; il sera annoncé aux inscrit·e·s avec les informations d'accès, la difficulté de marche et l'équipement." },
];

export const GUIDES = [
  { slug: "comment-choisir-la-peau-de-son-tambour", titre: "Quelle peau choisir ?", texte: "Cerf, cheval, chèvre, bison, bœuf, yak, autruche… ce que chaque peau change au son, au poids et au geste." },
  { slug: "quelle-taille-de-tambour-choisir", titre: "Quelle taille choisir ?", texte: "40, 45, 50 ou 60 cm : poids, profondeur du cadre, usage — des repères concrets pour trancher." },
  { slug: "comment-choisir-son-tambour", titre: "Comment choisir son tambour ?", texte: "Usage, sonorité, poids, peau, forme et ressenti : une méthode simple pour ne pas se tromper." },
  { slug: "la-symbolique-des-animaux", titre: "La signification des peaux", texte: "Traditions documentées, symbolisme contemporain et interprétation personnelle : savoir ce qui relève de quoi." },
  { slug: "les-lacages", titre: "Les différents laçages", texte: "4 branches, 5 branches, arbre de vie et autres possibilités — solidité, résonance et intention." },
  { slug: "apres-la-creation-de-son-tambour", titre: "Après la création", texte: "Séchage, première mise en vibration, humidité, tension, entretien et transport : faire durer son tambour." },
];

export const NIVEAUX = [
  {
    id: "classique", lettre: "A", titre: "Stage classique", sous: "Création complète en atelier, à Orbe",
    points: [`En groupe — dès CHF ${STAGE_PRICING.groupe}.–`, `Individuel ou privatisé — CHF ${STAGE_PRICING.individuel}.– (dès 3 pers. ${STAGE_PRICING.privatise4}.– / pers.)`, "Toute l'année, dates de l'agenda ou journée à convenir"],
    cta: { label: "Découvrir le stage classique", to: "/offres/stage-fabrication-tambour" },
  },
  {
    id: "editions", lettre: "B", titre: "Éditions limitées", sous: "Expériences ponctuelles, nombre réduit, contexte particulier",
    points: [`Super Lune — CHF ${STAGE_PRICING.editionSpeciale}.– · création de nuit`, `Solstice — CHF ${STAGE_PRICING.groupeSpecial}.– · rendez-vous annuel`, "Tambours des Lieux — en plein air"],
    cta: { label: "Voir les prochaines dates", to: "/agenda" }, accent: true,
  },
  {
    id: "sur-mesure", lettre: "C", titre: "Création sur mesure", sous: "Un projet qui sort des formats habituels",
    points: ["Formes particulières — ovale, ovoïde, octogonale…", "Grandes dimensions", "Peaux rares", "Projets d'artistes et demandes spécifiques"],
    cta: { label: "Faire une demande personnalisée", to: "/tambour-sur-mesure" },
  },
];
